module.exports = __webpack_public_path__ + "static/media/authImage.5f64fc62.jpg";